export const lithuanianCities = [
    { label: "Vilnius", value: "Vilnius", code: "vilniaus-ams" },
    { label: "Klaipėda", value: "Klaipėda", code: "klaipedos-ams" },
    { label: "Šiauliai", value: "Šiauliai", code: "siauliu-ams" }
];

// { label: "Kaunas", value: "Kaunas", code: "kauno-ams" },
// { label: "Panevėžys", value: "Panevėžys", code: "panevezio-ams" },
// { label: "Alytus", value: "Alytus", code: "alytaus-ams" },
// { label: "Marijampolė", value: "Marijampolė", code: "marijampoles-ams" },
// { label: "Mažeikiai", value: "Mažeikiai", code: "mazeikiu-ams" },
// { label: "Utena", value: "Utena", code: "utenos-ams" },
// { label: "Jonava", value: "Jonava", code: "jonavos-ams" },
// { label: "Telšiai", value: "Telšiai", code: "telsiu-ams" },
// { label: "Tauragė", value: "Tauragė", code: "taurages-ams" },
// { label: "Ukmergė", value: "Ukmergė", code: "ukmerges-ams" },
// { label: "Elektrėnai", value: "Elektrėnai", code: "elektrenu-ams" },
// { label: "Jurbarkas", value: "Jurbarkas", code: "jurbarko-ams" },
// { label: "Rokiškis", value: "Rokiškis", code: "rokiskio-ams" },
// { label: "Biržai", value: "Biržai", code: "birzu-ams" },
// { label: "Druskininkai", value: "Druskininkai", code: "druskininku-ams" },
// { label: "Šilutė", value: "Šilutė", code: "silutes-ams" },
// { label: "Šakiai", value: "Šakiai", code: "sakiu-ams" },
// { label: "Šalčininkai", value: "Šalčininkai", code: "salcininku-ams" },
// { label: "Švenčionys", value: "Švenčionys", code: "svencioniu-ams" },
// { label: "Šeduva", value: "Šeduva", code: "seduvos-ams" },
// { label: "Skuodas", value: "Skuodas", code: "skuodo-ams" },
// { label: "Molėtai", value: "Molėtai", code: "moletu-ams" },
// { label: "Trakai", value: "Trakai", code: "traku-ams" },
// { label: "Zarasai", value: "Zarasai", code: "zarasu-ams" },
// { label: "Kupiškis", value: "Kupiškis", code: "kupiskio-ams" },
// { label: "Kalvarija", value: "Kalvarija", code: "kalvarijos-ams" },
// { label: "Kybartai", value: "Kybartai", code: "kybartu-ams" },
// { label: "Lazdijai", value: "Lazdijai", code: "lazdiju-ams" },
// { label: "Rietavas", value: "Rietavas", code: "rietavo-ams" },
// { label: "Birštonas", value: "Birštonas", code: "birstono-ams" },
// { label: "Akmenė", value: "Akmenė", code: "akmenes-ams" },
// { label: "Pagėgiai", value: "Pagėgiai", code: "pagegiu-ams" }
